import Grid from "@material-ui/core/Grid";
import Helmet from "react-helmet";
import headersList from "Constants/headersList";
import Paper from "@material-ui/core/Paper";
import TextField from "@material-ui/core/TextField";
import { withSnackbar } from "notistack";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Button from "@material-ui/core/Button";
import React, { Component } from "react";
import InputValues from "Component/InputValues";
import PermissionDeniedComp from "Component/PermissionDeniedComp/PermissionDeniedComp";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { CheckActionPermission } from "Actions/commonAction";
import { instance } from "Actions/AxiosInstance";
import PageHeader from "Component/Headers/pageHeader";
import { ErrorMessages } from "Constants";
import SectionHeader from "Component/Headers/sectionHeader";
import TabContainer from "Component/Common/TabContainer";
import "./index.scss";

class Reminder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      before: [],
      after: [],
      beforetime: "",
      aftertime: "",
    };

    this.handleTabChange = this.handleTabChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.removeIndex = this.removeIndex.bind(this);
    this.addBeforeReminder = this.addBeforeReminder.bind(this);
    this.addAfterReminder = this.addAfterReminder.bind(this);
    this.onTimeChange = this.onTimeChange.bind(this);
    this.onSave = this.onSave.bind(this);
  }

  componentDidMount() {
    const [isTrue, permissions] = CheckActionPermission("remainder");
    if (isTrue) {
      this.setState({ permissions }, () => {
        this.getData();
      });
    } else {
      this.setState({ permissiondenied: true });
    }
  }

  getData() {
    instance
      .get(`perform/getreminderconfig`)
      .then((result) => {
        console.log("result: ", result);
        this.setState({
          before: result.data.result.filter((obj) => obj.remindertypeid == 1),
          after: result.data.result.filter((obj) => obj.remindertypeid == 2),
          other: result.data.result.filter(
            (obj) => obj.remindertypeid != 1 && obj.remindertypeid != 2,
          ),
          beforetime:
            result.data.result.filter((obj) => obj.remindertypeid == 1).length >
            0
              ? result.data.result.filter((obj) => obj.remindertypeid == 1)[0]
                  .remindertime
              : "",
          aftertime:
            result.data.result.filter((obj) => obj.remindertypeid == 2).length >
            0
              ? result.data.result.filter((obj) => obj.remindertypeid == 2)[0]
                  .remindertime
              : "",
        });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  handleTabChange(value) {
    this.setState({
      value,
    });
  }

  handleChange(set, value, i) {
    const { before, after } = this.state;
    if (set == "before") {
      before[i].reminddays = value;
    } else {
      after[i].reminddays = value;
    }
    this.setState({
      before,
      after,
    });
  }

  addBeforeReminder() {
    const { before } = this.state;
    before.push({
      reminderconfigid: null,
      remindertypeid: 1,
      reminddays: 1,
      remindertime: this.state.beforetime,
    });
    this.setState({
      before,
    });
  }

  addAfterReminder() {
    const { after } = this.state;
    after.push({
      reminderconfigid: null,
      remindertypeid: 2,
      reminddays: 1,
      remindertime: this.state.aftertime,
    });
    this.setState({
      after,
    });
  }

  onTimeChange(key, value) {
    this.setState({
      [key]: value,
    });
  }

  removeIndex(set, i) {
    const { before, after, beforetime, aftertime } = this.state;
    if (set == "before") {
      before.splice(i, 1);
    } else {
      after.splice(i, 1);
    }

    const tempbeforetime = before.length !== 0 ? beforetime : "";
    const tempaftertime = after.length !== 0 ? aftertime : "";

    this.setState({
      before,
      after,
      beforetime: tempbeforetime,
      aftertime: tempaftertime,
    });
  }

  // getData() {
  //   instance
  //   .get(`perform/getratingscale`).then((result) => {
  //     console.log('result: ', result);
  //     this.setState({ ratings: result.data.result });
  //   }).catch((error) => {
  //       this.props.enqueueSnackbar(error.response
  //         ? error.response.data.error.message
  //         : error.message, { variant: 'error' });
  //   });
  // }

  onSave() {
    const { value, beforetime, aftertime, after, before, other } = this.state;
    let beforevalidate = true;
    before.forEach((days) => {
      const arrResult = before.filter((x) => x.reminddays == days.reminddays);
      if (arrResult.length > 1) {
        beforevalidate = false;
      }
    });
    let aftervalidate = true;
    after.forEach((days) => {
      const arrResult = after.filter((x) => x.reminddays == days.reminddays);
      if (arrResult.length > 1) {
        aftervalidate = false;
      }
    });
    if (value == 0) {
      if (
        beforetime &&
        (before.length == 0 || before.find((x) => !x.reminddays))
      ) {
        this.props.enqueueSnackbar("please enter before due date reminder", {
          variant: "error",
        });
      } else if (beforevalidate == false) {
        this.props.enqueueSnackbar(
          "please enter different days for before due date reminder",
          { variant: "error" },
        );
      } else if (
        aftertime &&
        (after.length == 0 || after.find((x) => !x.reminddays))
      ) {
        this.props.enqueueSnackbar("please enter after due date reminder", {
          variant: "error",
        });
      } else if (aftervalidate == false) {
        this.props.enqueueSnackbar(
          "please enter different days for after due date reminder",
          { variant: "error" },
        );
      } else {
        instance
          .post(`perform/createreminderconfig`, {
            reminderconfig: [
              ...before.map((x) => ({
                ...x,
                remindertime:
                  beforetime.length < 6 ? `${beforetime}:00` : beforetime,
              })),
              ...after.map((x) => ({
                ...x,
                remindertime:
                  aftertime.length < 6 ? `${aftertime}:00` : aftertime,
              })),
              ...other.map((x) => ({
                ...x,
                remindertime: "00:00:00",
                reminddays: 2,
              })),
            ],
          })
          .then((result) => {
            this.getData();
            this.props.enqueueSnackbar(ErrorMessages.E0000, {
              variant: "success",
            });
          })
          .catch((error) => {
            this.props.enqueueSnackbar(
              error.response
                ? error.response.data.error.message
                : error.message,
              { variant: "error" },
            );
          });
      }
    }
  }

  render() {
    const { value, before, after } = this.state;
    return (
      <div className="innerwrapper-full-width">
        <Helmet>
          <title>{headersList.Config.Reminder.header}</title>
        </Helmet>
        {this.state.permissiondenied ? (
          <div className="position-rel">
            <PermissionDeniedComp />
          </div>
        ) : (
          <main className="content-outer-wrapper-with-tab">
            {value == 0 && (
              <TabContainer>
                <div className="margin-bottom-40">
                  <PageHeader header="Reminder" />
                  <Grid container className="margin-bottom-16">
                    <Grid md={12} sm={12}>
                      <Paper className="padding16">
                        <SectionHeader header="Before due date reminder" />
                        <div className="margin-bottom-16">
                          {before.map((obj, i) => (
                            <Grid container className="remove-paren">
                              <Grid md={11} sm={11}>
                                <div>
                                  <span className="normal-dark-secondary">
                                    Remind reviewers to review the employee
                                  </span>
                                  <span>
                                    <InputValues
                                      field="eligibledays"
                                      defaultvalue={""}
                                      min={1}
                                      max={30}
                                      disabled={
                                        this.state.permissions &&
                                        !this.state.permissions.editable
                                      }
                                      value={obj.reminddays}
                                      onChange={(e) =>
                                        this.handleChange(
                                          "before",
                                          parseInt(e.target.value),
                                          i,
                                        )
                                      }
                                    />
                                  </span>
                                  <span className="normal-dark-secondary">
                                    days before review due date.
                                  </span>
                                </div>
                              </Grid>
                              <Grid md={1} sm={1}>
                                <p
                                  className="remove-tag-hover cursour-pointer"
                                  style={{ color: "#f60038" }}
                                  onClick={() => this.removeIndex("before", i)}
                                >
                                  remove
                                </p>
                              </Grid>
                            </Grid>
                          ))}
                        </div>
                        {before.length < 3 && (
                          <span
                            className="normal-dark-secondary cursour-pointer margin-top-16 margin-bottom-16"
                            style={{ color: "#1e8ced" }}
                            onClick={this.addBeforeReminder}
                          >
                            + Add Reminder
                          </span>
                        )}
                        <div className="margin-top-16">
                          <span className="normal-dark-secondary">
                            Set Reminder time
                          </span>
                          <div>
                            <TextField
                              id="ShiftEnd"
                              style={{
                                width: "20%",
                                background: "white",
                                height: 40,
                              }}
                              margin="dense"
                              variant="outlined"
                              type="time"
                              disabled={
                                this.state.permissions &&
                                !this.state.permissions.editable
                              }
                              value={this.state.beforetime}
                              onChange={(e) =>
                                this.onTimeChange("beforetime", e.target.value)
                              }
                              inputProps={{
                                step: 1800, // 5 min
                              }}
                            />
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid md={12} sm={12}>
                      <Paper className="padding16">
                        <SectionHeader header="After due date reminder" />
                        <div className="margin-bottom-16">
                          {after.map((obj, i) => (
                            <Grid container className="remove-paren">
                              <Grid md={11} sm={11}>
                                <div>
                                  <span className="normal-dark-secondary">
                                    Remind reviewers to review the employee
                                  </span>
                                  <span>
                                    <InputValues
                                      field="eligibledays"
                                      defaultvalue={""}
                                      min={1}
                                      max={30}
                                      disabled={
                                        this.state.permissions &&
                                        !this.state.permissions.editable
                                      }
                                      value={obj.reminddays}
                                      onChange={(e) =>
                                        this.handleChange(
                                          "after",
                                          parseInt(e.target.value),
                                          i,
                                        )
                                      }
                                    />
                                  </span>
                                  <span className="normal-dark-secondary">
                                    {" "}
                                    day after review due date, if form is
                                    re-opened & reviewer hasn’t reviewed yet.
                                  </span>
                                </div>
                              </Grid>
                              <Grid md={1} sm={1}>
                                <p
                                  className="remove-tag-hover cursour-pointer"
                                  style={{ color: "#f60038" }}
                                  onClick={() => this.removeIndex("after", i)}
                                >
                                  remove
                                </p>
                              </Grid>
                            </Grid>
                          ))}
                        </div>
                        {after.length < 3 && (
                          <span
                            className="normal-dark-secondary cursour-pointer margin-top-16 "
                            style={{ color: "#1e8ced" }}
                            onClick={this.addAfterReminder}
                          >
                            + Add Reminder
                          </span>
                        )}
                        <div className="margin-top-16">
                          <span className="normal-dark-secondary">
                            Set Reminder time
                          </span>
                          <div>
                            <TextField
                              id="ShiftEnd"
                              style={{
                                width: "20%",
                                background: "white",
                                height: 40,
                              }}
                              margin="dense"
                              variant="outlined"
                              type="time"
                              disabled={
                                this.state.permissions &&
                                !this.state.permissions.editable
                              }
                              value={this.state.aftertime}
                              onChange={(e) =>
                                this.onTimeChange("aftertime", e.target.value)
                              }
                              inputProps={{
                                step: 1800, // 5 min
                              }}
                            />
                          </div>
                        </div>
                      </Paper>
                    </Grid>
                  </Grid>
                </div>
                {this.state.permissions && this.state.permissions.editable && (
                  <div
                    className="width100"
                    style={{
                      position: "fixed",
                      left: 0,
                      background: "white",
                      bottom: 0,
                      padding: 10,
                      borderTop: "1px solid #d4d4d4",
                      zIndex: 0,
                    }}
                  >
                    <div>
                      <div className="floatleft" style={{ marginLeft: 304 }}>
                        {/* <Button
                  className="btn btn-trans margin-right-16"
                  variant="contained"
                  onClick={() => {this.onca}}
                >
                  Cancel
                </Button> */}
                      </div>
                      <div className="floatright" style={{ marginRight: 72 }}>
                        <Button
                          className="btn btn-primary-md-blue"
                          variant="contained"
                          onClick={this.onSave}
                        >
                          Save
                        </Button>
                      </div>
                      <div className="clearfloat"></div>
                    </div>
                  </div>
                )}
              </TabContainer>
            )}
            {value == 1 && <div></div>}
          </main>
        )}
      </div>
    );
  }
}
const mapStateToProps = (state) => ({
  DynamicForm: state.dynamicformReducer,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withSnackbar(Reminder));
